import React from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Tab from "@material-ui/core/Tab";
import TabContext from "@material-ui/lab/TabContext";
import TabList from "@material-ui/lab/TabList";
import TabPanel from "@material-ui/lab/TabPanel";
import { Trad } from "../../../components";
import { _TabsInfoSection, _ChartsTab } from "../../components";

const useStyles = makeStyles(({ palette }: Theme) => ({
    content: {
        paddingLeft: 0
    },
    tabs: {
        borderRight: `1px solid ${palette.divider}`
    },
    tabPanel: {
        height: "100%",
        paddingBottom: 0,
        paddingTop: 0
    }
}));

interface IInfoTabsProps {
    ID_Anag: string;
    ID_FideAffidamento: string;
    ShowChartsTab?: boolean;
}

export const _InfoTabs: React.FC<IInfoTabsProps> = ({ ID_Anag, ID_FideAffidamento, ShowChartsTab }) => {
    const classes = useStyles();
    const tabs = ShowChartsTab ? ["Anagrafica", "Affidamento", "Grafici"] : ["Anagrafica", "Affidamento"];

    const [activeTab, setActiveTab] = React.useState("0");

    const onTabChange = (event: React.ChangeEvent<{}>, val: string) => {
        setActiveTab(val);
    };

    return (
        <Card>
            <CardContent className={classes.content}>
                <TabContext value={activeTab}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={2}>
                            <TabList centered orientation="vertical" textColor="primary" onChange={onTabChange} aria-label="info tabs" className={classes.tabs} indicatorColor="primary">
                                {tabs.map((label, index) => (
                                    <Tab label={Trad.Trad(label)} value={`${index}`} key={index} />
                                ))}
                            </TabList>
                        </Grid>
                        <Grid item xs={12} md={10}>
                            <TabPanel value="0" className={classes.tabPanel}>
                                <_TabsInfoSection DataUrl={`/api/anag/Contesto?ID_Anag=${ID_Anag}`} LinkUrl={`/anagrafica/${ID_Anag}`} />
                            </TabPanel>
                            <TabPanel value="1" className={classes.tabPanel}>
                                <_TabsInfoSection
                                    DataUrl={`/api/FideAffidamento/Contesto?ID_FideAffidamento=${ID_FideAffidamento}`}
                                    LinkUrl={`/anagrafica/${ID_Anag}/FideAffidamento/${ID_FideAffidamento}`}
                                />
                            </TabPanel>
                            {ShowChartsTab && (
                                <TabPanel value="2" className={classes.tabPanel}>
                                    <_ChartsTab ID_FideAffidamento={ID_FideAffidamento} />
                                </TabPanel>
                            )}
                        </Grid>
                    </Grid>
                </TabContext>
            </CardContent>
        </Card>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/BondsList/InfoTabs.tsx